import { types, Instance } from 'mobx-state-tree';
import { Providers } from './Providers';
export const RootSuperModel = types.model({
    providers: types.optional(Providers, {}),
})

export interface IRootSuperModel extends Instance<typeof RootSuperModel> { }
